export const STEPPER_MAX = 100
// TODO: WAITER_STEPPER_MAX=250
export const WAITER_NUMBER_PAD_MAX_LENGTH = 3
export const ESTIMATED_SHIPPING_TIME = 120 // minutes
export const STOREDELIVERY_TIMESLOT_DURATION = 30 // minuts
export const TAKEAWAY_TIMESLOT_DURATION = 15 // minuts
export const LALAMOVE_BUFFER = 15 // minuts
export const DEFAULT_RETRY_TIMES = 3 // minuts

export const ERROR_CODE_001 = '001'
export const ERROR_CODE_002 = '002'
export const ERROR_CODE_003 = '003'
export const ERROR_CODE_004 = '004'
export const ERROR_CODE_005 = '005'

export const PAYMENT_GATEWAY_FIRST_DATA = 'first-data'
export const PAYMENT_GATEWAY_STRIPE = 'stripe'



// WEBPACK FOOTER //
// ./src/constants/app.js